/**
 * Created by mykurisu on 2017/6/26.
 */
const defaults = {
    initialized: false,
    qrcodeShow: false,
    vippanelShow: false,
    channelList: [],
    classList: [],
    channel: null,
    lecture: null,
    channelinitialized: false,
    lectureinitialized:false,
    inviterId: null,
}

export default(state = defaults, action) => {
    switch (action.type) {
        case 'LIVEROOM_INIT':
            return {...state, initialized: true, ...action.payload};
        case 'LIVEROOM_CHANNEL':
            return {...state, channel: action.payload, channelinitialized: true};
        case 'LIVEROOM_LECTURE':
            return {...state, lecture: action.payload, lectureinitialized: true};
        case 'LIVEROOM_QRCODE_SHOW':
            return {...state, qrcodeShow: true};
        case 'LIVEROOM_QRCODE_HIDE':
            return {...state, qrcodeShow: false};
        case 'LIVEROOM_VIP_PANEL_SHOW':
            return {...state,vippanelShow: true};
        case 'LIVEROOM_VIP_PANEL_HIDE':
            return {...state,vippanelShow: false};
        case 'LIVEROOM_CHANNELS_INIT':
            return {...state,channelList: [...action.payload]};
        case 'LIVEROOM_CHANNELS_APPEND':
            return {...state,
                channelList: [...state.channelList,...action.payload.channels]};
        case 'LIVEROOM_LECTURES_INIT':
            return {...state,classList: [...action.payload]};
        case 'LIVEROOM_LECTURES_APPEND':
            return {...state,
                classList: [...state.classList,...action.payload.lectures]};
        case 'LIVEROOM_SET_VIP':
            return {...state,...action.payload};
        case 'LIVEROOM_UNSET_FANS':
            state.role.is_fans = false;
            return {...state};
        case 'LIVEROOM_SET_FANS':
            state.role.is_fans = true;
            return {...state};
        case 'LIVEROOM_SET_INVITERID':
            return {...state, inviterId: action.payload};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/liveroom.js